import { LineItemKey, ProductFilter } from '../../store/api';
import { shopPrefix } from '../../config';
import { http } from '../axios';

export type RemoveBulkByFilterRequest = {
    filterRequest: ProductFilter;
    excludedLineItemKeys: LineItemKey[];
};

const url = `${shopPrefix}/v2/selectionlists/:selectionListId/bulk/filter/remove`;

export const removeBulkFromListByFilter = (selectionListId: string, body: RemoveBulkByFilterRequest) => {
    return http
        .put<void>(url, body, {
            pathParams: {
                selectionListId
            }
        })
        .then(res => res.data);
};
